import axios from "axios";
import CryptoJS from "crypto-js";

export const getEnvironments = async (keys) => {
  const { data: tokenResult } = await axios({
    url:`${ process.env.REACT_APP_GATEWAY_2}/customers/api/v1/environment/gettoken`,
    //url: "http://localhost:5020/Api/v1/Environment/GetToken",
    method: "GET",
  });

  const decodedToken = atob(tokenResult?.token);

  if (!decodedToken) return null;

  const [token, publicKey, publicIV] = decodedToken.split("|");

  if (!token || !publicKey || !publicIV) return null;

  const { data } = await axios({
    url:`${ process.env.REACT_APP_GATEWAY_2}/customers/api/v1/environment/Get?source=hb-online`,
    //url: "http://localhost:5020/Api/v1/Environment/Get?source=hb-online",
    method: "POST",
    headers: {
      token,
    },
    data: keys,
  });

  if (!data?.data) return null;

  const result = decryptAES(publicKey, publicIV, data?.data);
  return result;
};

// 🔓 Función para descifrar
export const decryptAES = (publicKey, publicIV, encryptedText) => {
  const SECRET_KEY = CryptoJS.enc.Utf8.parse(publicKey);
  const IV = CryptoJS.enc.Utf8.parse(publicIV); // 16 bytes
  const bytes = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};
